<app-av-delete-popup id="actions" heading="{{data.title}}" closeText="CANCEL" action="DELETE" (closeDlg)="closeDialogue()" (saveData)="deleteUser()" class="actions">
    <div class="main-div">
        <p fxFlex="100" class="sec-title">
            <span> {{data.message}}
            </span>
        </p>
    </div>
</app-av-delete-popup>
